module.exports = __webpack_public_path__ + "static/tressym-6fe6ce54efdb1027cc42d7a79c1dd6e7.png";